import getApiClient from '@/plugins/api'

export default {
  loadItem() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`places/${itemId}`, {
      params: self.searchParams
    })
      .then((result) => {
        if (result.data.type) {
          result.data.type = result.data.type.toString()
        }
        self.place = result.data
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  loadCategories() {
    const self = this,
      api = getApiClient(self.$root.$store)

    self.$store.commit('startLoading')

    api.get('categories?pagination=false')
      .then((result) => {
        self.categories = result.data['hydra:member']
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  save() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id,
      payload = self.place

    let method = 'post',
      endpoint = 'places',
      headers = {}

    if (itemId) {
      method = 'patch'
      endpoint = `places/${itemId}`
      headers['Content-Type'] = 'application/merge-patch+json'
    }

    self.success = false
    self.error = false
    self.errors = {}
    self.$store.commit('startLoading')

    payload.categories = payload.categories.map(category => category['@id'])
    api[method](endpoint, payload, {headers: headers})
      .then(response => {
        self.place = response.data
        self.success = true
        self.$router.push({name: 'Editar destino', params: {id: response.data.id}})
      })
      .catch(error => {
        self.error = true
        self.processErrors(error.response.data.violations)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  processErrors(errors) {
    const self = this
    self.errors = {}

    errors.forEach(error => {
      self.errors[error.propertyPath] = error.message
    })
  },

  setType: function(type) {
    this.place.type = type.toString()
  },

  openCropper(files, model) {
    const self = this
    const image = files[0]

    this.croppingModel = model

    const reader = new FileReader()
    reader.readAsDataURL(image)
    reader.onload = e => {
      self.croppingImage = e.target.result
      self.showCropper = true
    }
  },

  closeCropper() {
    this.croppingImage = null
    this.showCropper = false
    this.croppingModel = null
  },

  setImage() {
    const { canvas } = this.$refs.imageCropper.getResult()
    switch (this.croppingModel) {
      case 'featuredImage':
        this.place.featuredImage = canvas.toDataURL('image/jpeg', 70)
        break
      case 'cover':
        this.place.cover = canvas.toDataURL('image/jpeg', 70)
        break;
    }
    this.croppingImage = null
    this.showCropper = false
    this.croppingModel = null
  },
}
